// extracted by mini-css-extract-plugin
export var alertIcon = "_sy-0";